import { useEffect } from 'react';
import KeyboardKey from "./KeyboardKey";

const Keyboard = ({highlights}) => {

    const keyList = [
        ['Q','W','E','R','T','Y','U','I','O','P'],
        ['A','S','D','F','G','H','J','K','L'],
        ['ENTER','Z','X','C','V','B','N','M','BACK']
    ]
    const keyPressed = (key) => {
        if (key === "BACK"){
          key = "Backspace";
        } else if (key === "ENTER"){
          key = "Enter";
        }
        const event = new KeyboardEvent('keyup', {
          key: key,
        });
        window.dispatchEvent(event);
      }  
    
    const onLetterIndexChanged = (event) => {
      console.log(`index changed ${event.index}`)
    }

    useEffect(() => { 
      window.addEventListener('letterIndexChanged', onLetterIndexChanged);
      return () => {
          window.removeEventListener("letterIndexChanged", onLetterIndexChanged);
        };
    }, []);

    const isHighlighted = (letter) => {
      if(letter.length > 1){
        return 'off';
      }
      if(highlights && highlights.indexOf(letter) === -1){
        return 'off;'
      }
      return 'on';
    }

    return (
        <div className='keyboard'>
            {keyList.map((row, i) => (
                <div className='keyboardRow' key={i}>
                    {row.map((letter, j) => (
                        < KeyboardKey letter={letter} key={j} keyPressCallback={keyPressed} highlight={isHighlighted(letter).toString()}/>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default Keyboard;